import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MapToggleService {
  private isMapToggledSubject = new BehaviorSubject<boolean>(true);
  isMapToggled$ = this.isMapToggledSubject.asObservable();

  toggleMap() {
    this.isMapToggledSubject.next(!this.isMapToggledSubject.value);
  }

  setMapState(state: boolean) {
    this.isMapToggledSubject.next(state);
  }
}
